<template>
  <router-view />
</template>

<script setup>
</script>

<style>
/* ═══ Global Reset & Base ═══ */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  /* 字体栈优先使用系统中文字体，避免方块乱码 */
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB',
               'Noto Sans SC', 'WenQuanYi Micro Hei', -apple-system,
               BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  color: #f1f5f9;
  background: #0b0f1a;
}
</style>
